<mat-checkbox class="mb-0100 pl-0100" *ngIf="allowSelectAll && events.length > 1"
  (change)="selectAllChanged($event)">Select all</mat-checkbox>

<mat-selection-list #eventList class="table entity-connection-group-table event-list-select b-shadow--medium2"
  [(ngModel)]="selectedEventIds" (selectionChange)="selectionsChanged()">

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <ng-container *ngFor="let day of calendarDays; let d = index;">
    <div class="day-header tr tr--noGutter">
      <h5>{{ day.date | date:'EEEE, M/d' }}</h5>
    </div>

    <mat-list-option *ngFor="let eventResult of day.events;" [value]="eventResult.id">
      <div class="event-row">
        <div class="event-time">
          <small class="color--gray--009">{{eventResult.startDate | date:'shortTime'}}</small>
        </div>
        <div class="event-title">
          <strong>{{eventResult.name}}</strong>
          <small class="d-block caps color--gray--009"
                 *ngIf="eventResult.endDate">
            <i class="far fa-hourglass-end mr-0025"></i>
            Until {{eventResult | eventEndTime}}
          </small>
        </div>
      </div>
    </mat-list-option>
  </ng-container>

  <ng-container *ngIf="calendarDays.length === 0">
    <div class="tr tr--noGutter no-events">
      <div class="td">
        <p class="color--gray--009">{{ loading ? 'Loading...' : 'No events found'}}</p>
      </div>
    </div>
  </ng-container>
</mat-selection-list>
